import { Box, Button, FormControl, FormLabel, IconButton, Input, TextField } from "@mui/material";
import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { MoreVert } from "@mui/icons-material";
import SegmentManageButton from "./SegmentManageButton";

const mode = {
    READ: "read",
    EDIT: "edit",
};

export function Segment({ segment, handleUpdateSegment, handleDeleteSegment }) {
    const title = segment?.data_segment_title ?? "";
    const [currentMode, setCurrentMode] = useState(mode.READ);
    const [newTitle, setNewTitle] = useState(title);

    const handleEdit = () => {
        setCurrentMode(mode.EDIT);
    };
    const handleDelete = () => {
        try {
            setCurrentMode(mode.READ);
            handleDeleteSegment(segment?.kpi_id, segment?.id);
        } catch (error) {}
    };
    const handleSave = () => {
        try {
            setCurrentMode(mode.READ);
            handleUpdateSegment(segment?.kpi_id, segment?.id, {
                title: newTitle,
            });
        } catch (error) {}
    };
    const handleCancel = () => {
        setCurrentMode(mode.READ);
    };

    return (
        <Box sx={{ marginY: 1 }}>
            {currentMode === mode.READ ? (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box>{title}</Box>
                    <Box>
                        <SegmentManageButton
                            segment={segment}
                            onClickEditSegment={handleEdit}
                            onClickDeleteSegment={handleDelete}
                        />
                    </Box>
                </Box>
            ) : (
                <Box>
                    <Box>
                        <FormControl fullWidth>
                            <FormLabel>ชื่อ segment</FormLabel>
                            <TextField
                                variant="outlined"
                                value={newTitle}
                                onChange={(event) => setNewTitle(event.target.value.trim())}
                            />
                        </FormControl>
                    </Box>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            marginTop: 2,
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={handleSave}>
                            save
                        </Button>
                        <Button onClick={handleCancel}>cancel</Button>
                    </Box>
                </Box>
            )}
        </Box>
    );
}
